import React, { useEffect } from 'react';
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { Button, Modal, Steps, Radio } from "antd";
import { updateModal } from '../../../store/actions/location';
import { handleClosePopup } from './locationUtils';
import { RadioButtonGroup, RadioButton } from '@vds/radio-buttons';
import { useDispatch, useSelector } from 'react-redux';

const LocationOptPopup = ({ visible, closePopup }) => {
  const dispatch = useDispatch();
  const next_modal = useSelector((state) => state.location?.next_modal);
  
  useEffect(() => {
    dispatch(updateModal({ next_modal: 'ShipmentLocation' }));
  },[]);

  return (
    <div>
      <Modal
        title=""
        open={visible}
        onCancel={() => { handleClosePopup({dispatch}); }}
        footer={[
          <Grid2
            container
            marginTop={0}
            marginBottom={0}
            spacing={2}
            columns={{ xs: 12 }}
          >
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-0">
                <Button
                  className="custom-button-cancel"
                  type="default"
                  onClick={() => { handleClosePopup({dispatch}); }}
                  shape="round"
                  style={{ fontWeight: "bold", width: "100%" }}
                  size={"large"}
                >
                  Cancel
                </Button>
              </div>
            </Grid2>
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-0">
                <Button
                  className="custom-button-save"
                  type="primary"
                  onClick={() => { dispatch(updateModal({ current_modal:  next_modal})); }}
                  shape="round"
                  style={{
                    width: "100%",
                    backgroundColor: "black",
                    color: "white",
                    fontWeight: "bold",
                  }}
                  size={"large"}
                >
                  Next
                </Button>
              </div>
            </Grid2>
          </Grid2>,
        ]}
        width={680}
      >
        <div style={{ marginBottom: "5px", marginTop: "5px" }}>
          <h2 className={"font-face-vzb page-header-location"}>
            Add location
          </h2>
          <Grid2
            container
            marginTop={1}
            marginBottom={2}
            spacing={1}
            columns={{ xs: 12 }}
            style={{ marginTop: "24px" }}
          >
            <Grid2 item xs={12} sm={12} md={12} lg={12} direction="row">
              <RadioButtonGroup
                name="locationType"
                value={next_modal}
                onChange={(e) => dispatch(updateModal({ next_modal: e?.target?.value }))}
                style={{ display: "flex", flexDirection: "column", gap: 16 }}
                className="ats-radio-group align-left-ats-radio-group"
              >
                <RadioButton
                  value="inventory_location"
                  label={
                    <div className="d-flex flex-column justify-content-center align-items-start">
                      <div
                        style={{
                          fontFamily: "VerizonNHGDSBold",
                          fontWeight: 700,
                          fontSize: "16px",
                          lineHeight: "20px",
                        }}
                      >
                        Inventory location
                      </div>
                      <div
                        style={{
                          fontFamily: "VerizonNHGDS",
                          fontWeight: 400,
                          fontSize: "16px",
                          lineHeight: "20px",
                        }}
                      >
                        For tracking assets
                      </div>
                    </div>
                  }
                  disabled={false}
                  name="locationType"
                />
                <RadioButton
                  value="ShipmentLocation"
                  label={
                    <div className="d-flex flex-column justify-content-center align-items-start">
                      <div
                        style={{
                          fontFamily: "VerizonNHGDSBold",
                          fontWeight: 700,
                          fontSize: "16px",
                          lineHeight: "20px",
                        }}
                      >
                        Shipment location
                      </div>
                      <div
                        style={{
                          fontFamily: "VerizonNHGDS",
                          fontWeight: 400,
                          fontSize: "16px",
                          lineHeight: "20px",
                        }}
                      >
                        For tracking shipments
                      </div>
                    </div>
                  }
                  disabled={false}
                  name="locationType"
                />
              </RadioButtonGroup>
            </Grid2>
          </Grid2>
        </div>
      </Modal>
    </div>
  );
};

export default LocationOptPopup;